// extracted by mini-css-extract-plugin
module.exports = {"text":"Treebank_text__38CzO","graph":"Treebank_graph__1l6uy"};